var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.categories,"item-text":"name","item-value":"id","loading":_vm.loading,"value":_vm.category,"return-object":""},on:{"change":_vm.handleSelect}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }